import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { DrawerFichaImpresionDocumento } from "../../action/actionCreators"

import { EnviarPresupuestoEnAPI, ObtenerListadoLicenciasSertecHTMLEnAPI, ObtenerListadoLicenciasSertecCSVEnAPI, ObtenerListadoLicenciasSertecPDFEnAPI } from "../../action/actionCreatorsRequests"
import { MSGOK, convertirMoneda, calculoLineaFacturacion, dynamicSortDesc, dynamicSortAsc, calculoTotalesPresupuesto, descargarDocPasandoBase64Generico, MSGERROR, descargarPdfPasandoBase64, traducirPagina } from '../../librerias/funciones'
import { MDBBtn, MDBCol } from 'mdbreact';
import {
    CloseOutlined,
    MailOutlined,
    PrinterOutlined,
    ZoomInOutlined,
    ZoomOutOutlined,
    ArrowDownOutlined,
    FilePdfFilled,
    FileExcelFilled,
    FileExcelOutlined,
    FilePdfOutlined

} from '@ant-design/icons';

import { Card, Input, Row, Col, Drawer, Tabs } from 'antd';
import store from "../../store";
const { TabPane } = Tabs;

const FichaImpresionDocumento = ({ props, configApp, openDrawerFichaImpresionDocumento, datosFacturacion }) => {
    const [hayDocumento, setHayDocumento] = React.useState(false);
    const [documento, setDocumento] = React.useState("");
    const [escalaPorDefecto, setEscalaPorDefecto] = React.useState(0.50);
    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID_PRESUPUESTO: null,
        }
    );



    if (!hayDocumento && openDrawerFichaImpresionDocumento) {
        setHayDocumento(true);

        ObtenerListadoLicenciasSertecHTMLEnAPI(props.LICENCIAS).then((doc) => {
            if (doc !== undefined) {
                if (doc !== null || doc !== "") {
                    setDocumento(doc)
                } else {
                    setDocumento(null)
                }
            }
        })


    } else {
        if (!openDrawerFichaImpresionDocumento && hayDocumento) {
            setDocumento("");
            setEscalaPorDefecto(0.50)
            setHayDocumento(false);
            setPayLoadLocal({
                ID_PRESUPUESTO: null,
            })
        }
    }


    const printDiv = () => {
        //let data = document.getElementsByClassName("containerDocumento");
        //let data = document.getElementsByClassName("ContenedorDocumento");

        if (documento !== "") {

            let myWindow = window.open('', 'my div', 'height=600,width=600');
            //myWindow.document.write('<html><head><title>my div</title>');
            //myWindow.document.write('</head><body >');
            myWindow.document.write(documento);
            //myWindow.document.write('</body></html>');
            myWindow.document.close();

            myWindow.onload = function () {
                myWindow.focus();
                myWindow.print();
                myWindow.close();
            };
        }
    }


    const obtenerDocumento = () => {
        ObtenerListadoLicenciasSertecPDFEnAPI(props.LICENCIAS).then((doc) => {
            if (doc !== undefined) {
                if (doc.PDF !== "" && doc.PDF !== null) {
                    descargarPdfPasandoBase64(doc.PDF)
                }
            }
        })
    }


    const obtenerDocumentoCSV = () => {
        ObtenerListadoLicenciasSertecCSVEnAPI(props.LICENCIAS).then((doc) => {
            if (doc !== undefined) {

                if (doc.CSV !== "" && doc.CSV !== null) {
                    descargarDocPasandoBase64Generico(doc.CSV, "csv")
                }

            }
        })
    }


    return (
        <Drawer
            width={435}
            onClose={() => {
                store.dispatch(DrawerFichaImpresionDocumento(false));
            }}
            visible={openDrawerFichaImpresionDocumento}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            closable={false}
            style={{ zIndex: '999999999999', color: '#fff' }}>



            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => { store.dispatch(DrawerFichaImpresionDocumento(false)); }}></CloseOutlined >
                    <div> {props.title}</div>
                </div>

                <div className='itemHeaderDrawer2'>

                </div>
            </div>





            <div className="ant-drawer-header" style={{ backgroundColor: '#676767', color: '#021323', borderBottom: '0px', borderRadius: '0px', padding: '0px 0px' }}>
                <div className="flex-container">
                    <div style={{ flexGrow: '1', textAlign: 'end', color: '#fff', verticalAlign: 'middle', fontSize: '16px' }}>
                        <button style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767', marginBottom: '5px', marginRight: '5px' }} title={traducirPagina("Aumentar")} onClick={(e) => {
                            let operacion = escalaPorDefecto + 0.01
                            setEscalaPorDefecto(operacion)
                        }}>
                            <ZoomInOutlined style={{ fontSize: '22px' }} />

                        </button>

                        <button style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767' }} title={traducirPagina("Reducir")} onClick={(e) => {
                            let operacion = escalaPorDefecto - 0.01
                            setEscalaPorDefecto(operacion)
                        }}>
                            <ZoomOutOutlined style={{ fontSize: '22px' }} />

                        </button>

                        <button style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767' }} title={traducirPagina("Descargar_csv")} onClick={(e) => {
                            obtenerDocumentoCSV()
                        }}>
                            <FileExcelOutlined style={{ fontSize: '20px' }} />

                        </button>

                        <button style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767' }} title={traducirPagina("Descargar_pdf")} onClick={(e) => {
                            obtenerDocumento()
                        }}>
                            <FilePdfOutlined style={{ fontSize: '20px' }} />

                        </button>

                        <button style={{ height: '40px', width: '40px', border: '0', borderRadius: '3px', fontSize: '13px', verticalAlign: 'text-top', color: '#fff', backgroundColor: '#676767', marginRight: '5px' }} title={traducirPagina("Ver_documento")} onClick={(e) => {
                            printDiv("ContainerDocumento")
                        }}>
                            <PrinterOutlined style={{ fontSize: '22px' }} />

                        </button>

                    </div>

                </div>
            </div>

            <div className="p-2" style={{ height: (configApp.height - 95 ).toString() + "px", overflow: 'auto', backgroundColor: '#525659' }}   >

                <div className="ml-2 mr-2 mt-2" id="ContainerDocumento">

                    <div style={{ width: '780px', transform: 'scale(' + escalaPorDefecto + ')', transformOrigin: 'left top 0px', height: '100%' }} dangerouslySetInnerHTML={{ __html: documento }} />

                </div>


            </div>
        </Drawer>
    )
}


FichaImpresionDocumento.propTypes = {
    title: PropTypes.string,
    idDocumento: PropTypes.number,
    LICENCIAS: PropTypes.array,
    ID_SOCIO: PropTypes.number
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        openDrawerFichaImpresionDocumento: state.estadoDrawer.openDrawerFichaImpresionDocumento,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        VehiculoTallerSeleccionado: state.VehiculoTallerSeleccionado,
        datosFacturacion: state.datosFacturacion
    };
}

export default connect(mapStateToProps)(FichaImpresionDocumento);